//Queda a futuro cuando se defina un id o valor unico para cada estado, se usa el ID de los estados mas abajo
export const EN_PROCESO_STATUS: string = 'En Proceso';
export const APROBADA_STATUS: string = 'Aprobada';
export const RECHAZADA_STATUS: string = 'Rechazada';
export const INICIO_STATUS: string = 'Inicio Solicitud';
export const ANULADA_STATUS: string = 'Anulada';
export const REVISION_STATUS: string = 'Revision';
export const FINALIZADA_STATUS: string = 'Finalizada';
export const OBSERVADA_STATUS: string = 'Observada';
export const EN_ACTUALIZACION_STATUS: string = 'Actualizacion';

export const EN_PROCESO_STATUS_ID: number = 10;
export const OBSERVADA_STATUS_ID: number = 11;
export const APROBADA_STATUS_ID: number = 12;
export const RECHAZADA_STATUS_ID: number = 13;
export const INICIO_STATUS_ID: number = 14;
export const ANULADA_STATUS_ID: number = 15;
export const REVISION_STATUS_ID: number = 16;
export const EN_ACTUALIZACION_STATUS_ID: number = 17;
export const FINALIZADA_STATUS_ID: number = 18;

export const APROBADO_DOCUMENTO_STATUS: string = 'APROBADO';
export const NO_APROBADO_DOCUMENTO_STATUS: string = 'NO_APROBADO';
export const SIN_VISAR_DOCUMENTO_STATUS: string = 'SIN_VISAR';

// Valores de status de documentos de Habilitación Contratista (mantis 0198892)
export const OK_DOCUMENTO_STATUS: string = 'OK';
export const NO_OK_DOCUMENTO_STATUS: string = 'NoOK';

// Estados Habilitación Contratista (ajustar IDs al integrar con backend)
export const EN_PROCESO_CARGA_HAB_STATUS: string = 'En Proceso de Carga';

// IDs de estados del flujo Habilitación Contratista (mantis 0198892)
// Valores tomados de tipos_estados — coinciden con los IDs existentes del flujo Solicitud
export const HAB_REVISION_STATUS_ID: number = 16;
export const HAB_OBSERVADA_STATUS_ID: number = 11;
export const HAB_APROBADA_STATUS_ID: number = 12;
export const HAB_ACTUALIZACION_STATUS_ID: number = 17;
export const HAB_FINALIZADA_STATUS_ID: number = 18;

// Códigos de situación contractual del personal de habilitación (CU13 — mantis 0200062)
// Coinciden con los valores persistidos en BD (no usar las descripciones largas del doc CU13)
export const SITUACION_PERSONAL_PROPIO: string = 'PROPIO';
export const SITUACION_PERSONAL_SUBCONTRATADO: string = 'SUBCONTRATADO';
export const SITUACION_PERSONAL_AUTONOMO: string = 'AUTONOMO';
